import React, { useState, useEffect } from 'react';
import Sidemenu from '../base/sidemenu';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { formatMobilePhone, formatOfficePhone } from '../../utils/phoneFormatter'
import "./AdminEditRedesign.css";
export default function AdminEdit() {
  const location = useLocation();
  const navigate = useNavigate();
  const admin = location.state?.admin || {};
  console.log("location.state.admin 값:", admin);
  const [deptList, setDeptList] = useState([]);
  const [authList, setAuthList] = useState([]);
  useEffect(() => {
    console.log("초기 상태값들:", {
      id, username, name, auth, email, department, phone, mobile_phone, password,
    });
  }, []);
  // 상태 관리
  const [id] = useState(admin.id || "");
  const [username, setUsername] = useState(admin.username || "");
  const [password, setPassword] = useState(admin.password || ""); // 기존 비밀번호는 빈값으로 두고, 변경 시에만 입력 받음
  const [new_password, setNewPassword] = useState("");
  const [name, setName] = useState(admin.name || "");
  const [auth, setAuth] = useState(admin.auth_name || "");
  const [email, setEmail] = useState(admin.email || "");
  const [department, setDepartment] = useState(admin.department || "");
  const [phone, setPhone] = useState(admin.phone || "");
  const [mobile_phone, setMobile_phone] = useState(admin.mobile_phone || "");


  // 로그인한 사용자의 권한 디코딩
  const decodeToken = (token) => {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        window
          .atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error("토큰 디코딩 실패:", error);
      return null;
    }
  };
  const token = localStorage.getItem("token");
  const decoded = decodeToken(token);
  const loginAuth = decoded?.auth;

  // 소속, 권한 목록 API 호출 (필요시 경로 조정)
  useEffect(() => {
    const fetchSelectLists = async () => {
      try {
        const [authRes, deptRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/auth`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${process.env.REACT_APP_API_BASE_URL}/department`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        setAuthList(Array.isArray(authRes.data) ? authRes.data : authRes.data.auth || []);
        setDeptList(Array.isArray(deptRes.data) ? deptRes.data : deptRes.data.department || []);
      } catch (error) {
        console.error("선택박스 데이터 불러오기 실패:", error);
        alert("소속 또는 권한 정보를 불러오는 데 실패했습니다.");
      }
    };

    fetchSelectLists();
  }, [token]);

  //
  const handleMobilePhoneChange = (e) => {
    const inputValue = e.target.value;
    const formattedValue = formatMobilePhone(inputValue);
    setMobile_phone(formattedValue);
  };

  const handleOfficePhoneChange = (e) => {
    const inputValue = e.target.value;
    const formatted = formatOfficePhone(inputValue);
    setPhone(formatted);
  };


  // 수정 요청
  const handleUpdate = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      };

      const selectedAuth = authList.find(a => a.name === auth);
      const selectedDept = deptList.find(d => d.name === department);

      const body = {
        id,
        username,
        password,
        new_password,
        name,
        auth: selectedAuth?.id || 2,
        email,
        department: selectedDept?.id || "",
        phone,
        mobile_phone
      };
      console.log("authList", authList);
      console.log("선택된 auth 이름:", auth);
      console.log("선택된 auth ID:", selectedAuth?.id);

      const response = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/admin`, body, config);

      if (response.data.success === false) {
        alert(response.data.message);
        return;
      }
      alert(response.data.message);
      navigate("/admin");
    } catch (error) {
      console.error("수정 요청 실패:", error);
      alert("수정 중 오류가 발생했습니다.");
    }
  };

return (
  <div className="flex admin-edit-redesign-layout">
    <Sidemenu />

    <main className="admin-edit-redesign-content">
      <div className="ae-page">
        <div className="ae-top">
          <button className="ae-back" onClick={() => navigate(-1)}>
            ← 관리자 상세정보
          </button>
        </div>

        <div className="ae-heading">
          <h2>관리자 정보 수정</h2>
          <p>{name || "관리자"}님의 계정 및 소속 정보를 수정할 수 있습니다.</p>
        </div>

        <section className="ae-card">
          <div className="ae-card-title">
            <h3>기본 정보</h3>
            <span>관리자 계정 및 연락처 정보</span>
          </div>

          <div className="ae-grid">
            <div className="ae-field">
              <label htmlFor="ae-name">이름</label>
              <input id="ae-name" type="text" value={name}
                onChange={e => setName(e.target.value)} />
            </div>

            <div className="ae-field">
              <label htmlFor="ae-username">아이디</label>
              <input id="ae-username" type="text" value={username} disabled />
            </div>

            <div className="ae-field">
              <label htmlFor="ae-mobile">휴대폰 번호</label>
              <input id="ae-mobile" type="text" value={mobile_phone}
                onChange={handleMobilePhoneChange} />
            </div>

            <div className="ae-field">
              <label htmlFor="ae-phone">내선번호</label>
              <input id="ae-phone" type="text" value={phone}
                onChange={handleOfficePhoneChange} />
            </div>

            <div className="ae-field">
              <label htmlFor="ae-email">이메일</label>
              <input id="ae-email" type="text" value={email}
                onChange={e => setEmail(e.target.value)} />
            </div>

            <div className="ae-field">
              <label htmlFor="ae-department">소속</label>
              {loginAuth === 1 ? (
                <select id="ae-department" value={department}
                  onChange={e => setDepartment(e.target.value)}>
                  <option value="" disabled>선택</option>
                  {deptList.map(item => (
                    <option key={item.id} value={item.name}>{item.name}</option>
                  ))}
                </select>
              ) : (
                <div className="ae-readonly">{department || "-"}</div>
              )}
            </div>

            <div className="ae-field">
              <label htmlFor="ae-auth">권한</label>
              {loginAuth === 1 ? (
                <select id="ae-auth" value={auth}
                  onChange={e => setAuth(e.target.value)}>
                  <option value="" disabled>선택</option>
                  {authList.map(item => (
                    <option key={item.id} value={item.name}>{item.name}</option>
                  ))}
                </select>
              ) : (
                <div className="ae-readonly">{auth || "-"}</div>
              )}
            </div>
          </div>
        </section>

        <section className="ae-card">
          <div className="ae-card-title">
            <h3>비밀번호 변경</h3>
            <span>비밀번호를 변경할 경우에만 입력하세요.</span>
          </div>

          <div className="ae-grid">
            <div className="ae-field">
              <label htmlFor="ae-password">현재 비밀번호</label>
              <input id="ae-password" type="password" value={password}
                onChange={e => setPassword(e.target.value)}
                autoComplete="current-password"
                placeholder="현재 비밀번호 입력" />
            </div>

            <div className="ae-field">
              <label htmlFor="ae-new-password">새 비밀번호</label>
              <input id="ae-new-password" type="password" value={new_password}
                onChange={e => setNewPassword(e.target.value)}
                autoComplete="new-password"
                placeholder="새 비밀번호 입력" />
            </div>
          </div>
        </section>

        <div className="ae-actions">
          <button className="ae-secondary" onClick={() => navigate(-1)}>
            뒤로
          </button>
          <button className="ae-primary" onClick={handleUpdate}>
            수정완료
          </button>
        </div>
      </div>
    </main>
  </div>
);


}
